import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20background%20with%20warm%20ambient%20glowing%20red%20and%20gold%20stage%20curtains%2C%20elegant%20spotlight%20beams%2C%20luxurious%20movie%20theater%20atmosphere%2C%20dramatic%20lighting%2C%20rich%20velvet%20textures%2C%20premium%20entertainment%20venue&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
          alt="小蓝视频 - 高清在线观影"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
            汇聚精彩
            <span className="text-primary-400"> 一网打尽</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            香蕉视频·糖豆视频·茄子视频·糖心视频·苹果视频·青青草视频 ——
            <strong className="text-white font-semibold">高清免费在线观看</strong>，不缓冲最新电影电视剧大全
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianying"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
            >
              <i className="ri-play-circle-fill mr-2"></i>立即观影
            </Link>
            <Link
              to="/category/dianshiju"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold hover:bg-white/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-tv-2-line mr-2"></i>热播剧集
            </Link>
          </div>
        </div>

        <div className="hidden md:grid grid-cols-3 gap-4 mt-12 w-full max-w-4xl">
          {featuredVideos.map((video, index) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer transform hover:scale-105 transition-all duration-300"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs px-2 py-0.5 bg-accent-500 text-white rounded-full font-medium">
                    {video.platform}
                  </span>
                  <span className="text-xs text-white/70">{video.category}</span>
                </div>
                <h3 className="text-white font-semibold text-sm">{video.title}</h3>
                <p className="text-white/60 text-xs mt-0.5">{video.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}